import { QueryClient, QueryKey } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

type OnQuerySuccessProps = {
  queryClient?: QueryClient;
  queryKeysToInvalidate?: QueryKey[];
  successMessage?: string;
  callback?: () => void;
};

type OnQueryErrorProps = {
  errorMessage?: string;
  callback?: () => void;
};

export const onQuerySuccess = ({
  queryClient,
  queryKeysToInvalidate,
  successMessage,
  callback,
}: OnQuerySuccessProps) => {
  queryKeysToInvalidate?.forEach((queryKey) => {
    queryClient?.invalidateQueries({ queryKey, refetchType: 'active' });
  });

  if (successMessage) {
    enqueueSnackbar(successMessage, {
      variant: 'success',
      autoHideDuration: 2000,
      anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    });
  }
  callback?.();
};

export const onQueryError = ({ errorMessage, callback }: OnQueryErrorProps) => {
  if (errorMessage) {
    enqueueSnackbar(errorMessage, {
      variant: 'error',
      autoHideDuration: 2000,
      anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    });
  }
  callback?.();
};
